module.exports = __webpack_public_path__ + "img/hourglass.0c66628.png";